<template>
  <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="1.28374"
      y="1.28374"
      width="25.0483"
      height="25.0483"
      rx="6.3412"
      stroke="currentColor"
      stroke-width="0.567486"
    />
    <path
      d="M15.8673 16.1672V26.6156H11.4671V16.1672H8.24969V12.9095H11.4671V11.0612C11.4671 8.28814 13.7151 6.04016 16.4882 6.04016H20.1255V9.41L18.5592 9.2789C17.0809 9.15516 15.789 10.2689 15.6936 11.7493L15.6189 12.9095H20.1255L18.7416 16.1672H15.8673Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: "FacebookIcon"
};
</script>
